import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const Gallery1 = ({ images }) => {
	return (
		<section className="py-5 py-lg-7">
			<Container>
				<Row>
					<Col>
						<div style={{ position: "relative" }}>
							<Carousel
								responsive={{
									allDevices: {
										breakpoint: { max: 4000, min: 0 },
										items: 1, // Show one item at a time
									},
								}}
								className="pb-9"
								infinite
								showDots
								renderDotsOutside
								customLeftArrow={<CustomLeftArrow />}
								customRightArrow={<CustomRightArrow />}
								itemClass="carousel-item-padding"
							>
								{images.map((study) => {
									const bgImage = getImage(study.image.localFile);

									return (
										<GatsbyImage
											image={bgImage}
											className="carousel-item position-relative big-case-study"
											style={carouselItemStyles}
										/>
									);
								})}
							</Carousel>
						</div>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

// Custom Left Arrow
const CustomLeftArrow = ({ onClick }) => (
	<button
		onClick={onClick}
		className="custom-arrow custom-left-arrow"
		style={{ ...arrowStyles2, right: "60px" }}
	>
		<FaArrowLeft className="fs-5" />
	</button>
);

// Custom Right Arrow
const CustomRightArrow = ({ onClick }) => (
	<button
		onClick={onClick}
		className="custom-arrow custom-right-arrow"
		style={{ ...arrowStyles2, right: "0px" }}
	>
		<FaArrowRight className="fs-5" />
	</button>
);

// Inline styles
const carouselItemStyles = {
	position: "relative",

	borderRadius: "12px",
	backgroundSize: "cover",
	backgroundPosition: "center",
	overflow: "hidden",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
};

const arrowStyles2 = {
	position: "absolute",
	bottom: "0px",
	transform: "translateY(-50%)",
	zIndex: 2,
	backgroundColor: "white",
	border: "1px solid #00304B",
	borderRadius: "50%",
	width: "50px",
	height: "50px",
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	cursor: "pointer",
	boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
};

export default Gallery1;
